import { render, staticRenderFns } from "./OnlineShoppingPage.vue?vue&type=template&id=08cfd4c4&scoped=true&"
import script from "./OnlineShoppingPage.vue?vue&type=script&lang=js&"
export * from "./OnlineShoppingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cfd4c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08cfd4c4')) {
      api.createRecord('08cfd4c4', component.options)
    } else {
      api.reload('08cfd4c4', component.options)
    }
    module.hot.accept("./OnlineShoppingPage.vue?vue&type=template&id=08cfd4c4&scoped=true&", function () {
      api.rerender('08cfd4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnlineShoppingPage.vue"
export default component.exports